import styled from 'styled-components';

export const Wrapper = styled.section<{$error: boolean}>`
  display: flex;
  flex-direction: column; 
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme, $error }) => $error ? theme.colors.error : theme.colors.border};

  & select option {
    color: ${props => props.theme.colors.text.secondary};
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
  }
`;

export const Select = styled.select<{$error: boolean}>`
  width: 100%;
  padding: 13px;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 8px;
  background: white;
  font-size: 16px;
  position: relative;
  
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  color: ${({ theme, $error }) => $error ? theme.colors.error : theme.colors.text.secondary};

  &:focus {
    border: 1px solid ${props => props.theme.colors.border};
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }
`;

export const ErrorMessage = styled.span`
  display: flex;
  width: 100%;
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 12.1px;
  text-align: left;
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.error};
`;
